import React, { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import { ISegmentOffer } from './type';

const useService = () => {
	const [segmentLabelList, setSegments] = React.useState<{ id: number; label: string }[]>([{ id: 0, label: 'HELLO' }]);
	const [mapValueList, setMapValues] = React.useState<Object>({});
	const { postData } = useContext(AjaxContext);
	const getCTDOfferData = useCallback(
		async ({
			app,
			pageDetails,
			sortDetails,
			filterDetails
		}: {
			app: any;
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { isGold, appName } = app;
			const response = await postData({
				endpoint: '/marketing/dashboard/finance/getCTDActiveOffers',
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isGold
				},
				queryParams: {
					appName
				}
			});
			const listData = formatListData({ ...response?.data?.data?.ctdOffers });
			for (let idx = 0; idx < listData.length; idx += 1) listData[idx].index = idx + 1;
			const segmentExp = response?.data?.data?.segmentExp;
			const segments: string[] = Object.keys(segmentExp);
			const segmentList: { id: string; label: string }[] = [];
			const mapValues: {
				segmentExp: { [key: string]: { expName: string } };
				expBucket: {
					[key: string]: { share: number; name: string }[];
				};
				segmentBucketRank: { _id: { segmentName: string; bucketName: string }; maxRank: number };
			} = {
				segmentExp: response?.data?.data?.segmentExp,
				expBucket: response?.data?.data?.expBucket,
				segmentBucketRank: response?.data?.data?.segmentBucketRank
			};
			segments.forEach((segment: string) => segmentList.push({ id: segment, label: segment }));
			setSegments(segmentList);
			setMapValues(mapValues);
			const count = response?.data?.data?.ctdOffers?.length;
			return { rowCount: count, data: listData };
		},
		[]
	);

	const requestCreateOffer = useCallback((appName: string, data: ISegmentOffer) => {
		const dataList = [];
		dataList.push(data);
		return postData({
			endpoint: '/marketing/dashboard/finance/createCTDOffers',
			body: { ctdOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateOffer = useCallback((appName: string, data: ISegmentOffer) => {
		return postData({
			endpoint: '/marketing/dashboard/finance/updateCTDOffers',
			body: { ctdOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestDisableOffer = useCallback((appName: string, data: ISegmentOffer) => {
		return postData({
			endpoint: '/marketing/dashboard/finance/disableCTDOffers',
			body: { ctdOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const toggleIsDisabledField = useCallback(async (rowData: any, history: any, user: any, app: any, showAlert: any) => {
		const data = rowData;
		data.isActive = !data.isActive;

		try {
			const response = await requestDisableOffer(app.appName, { ...data });
			if (response.status !== 200 || !response.data.success) {
				showAlert(response.data.error || 'Error occured while disabling an offer', { type: 'error' });
				history.goBack();
				return;
			}
			showAlert('Offer Disabled');
		} catch (error: any) {
			data.isDisabled = !data.isDisabled;
			showAlert(error.response.data.error || 'Error occured while disabling an offer', { type: 'error' });
		}
	}, []);

	return {
		getCTDOfferData,
		requestUpdateOffer,
		requestCreateOffer,
		toggleIsDisabledField,
		segmentLabelList,
		mapValueList
	};
};

export default useService;
